<div class="group">
  <slot />
</div>

<style>
  .group {
    display: flex;
    background-color: var(--rekki-neutral-01);
    min-height: var(--min-height);
    height: var(--height);
    border-radius: 100px;
    padding: 2px;
    justify-content: center;
  }
</style>
